//(function () {
//    'use strict';

//    angular.module("imApp").factory("selectableProductsService", [function () {
//        let service = {};

//        return service;
//    }]);
//})();
